import type React from 'react';
import { useLayoutEffect } from 'react';

import { useProjectLoading } from 'contexts/ProjectLoadingContext';

import { Loader } from '@polyai/ui/components/atoms/Loader';

import useLatencyViz from 'hooks/useLatencyViz';
import { PROJECT_RESOURCE } from 'hooks/useProjectResources';
import ErrorPage, { ErrorStatus } from 'screens/ErrorPage';
import withPermissions from 'screens/withPermissions';

const LatencyVizScreen: React.FC = () => {
  const { htmlContent, isLoading, error } = useLatencyViz();

  // This route bypasses ProjectPage, so dismiss the ProjectLoadingOverlay
  const { setNavLoading, setContentLoading } = useProjectLoading();
  useLayoutEffect(() => {
    setNavLoading(false);
    setContentLoading(false);
  }, [setNavLoading, setContentLoading]);

  if (isLoading) {
    return <Loader fullScreen logo />;
  }

  if (error) {
    return <ErrorPage type={ErrorStatus.UNHANDLED_ERROR} />;
  }

  return (
    <iframe
      sandbox="allow-scripts"
      srcDoc={htmlContent}
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
      }}
      title="Latency Visualization"
    />
  );
};

export default withPermissions(
  LatencyVizScreen,
  PROJECT_RESOURCE.CONVERSATIONS,
  'latency_viz',
);
